// @flow weak

import React from 'react';
import { compose, defaultProps } from 'recompose';

import LoadingBlock from 'app/common/components/LoadingBlock';
import MaybeLoad from 'app/common/components/MaybeLoad';
import { purifyWithDeepCheck } from '@zapier/perf-utils';

import type { HOC } from 'recompose';

type LoadingBlockOrComponentProps = {
  Component: Function,
  isLoading: boolean,
  LoadingComponent?: Function,
  onLoad: Function,
};

const LoadingBlockOrComponent = componentProps => {
  const { Component, isLoading, LoadingComponent, ...props } = componentProps;
  return (
    <MaybeLoad
      Component={isLoading ? LoadingComponent : Component}
      {...props}
    />
  );
};

const defaultPropsValue = {
  LoadingComponent: LoadingBlock,
};

const enhanceLoadingBlockOrComponent: HOC<
  *,
  LoadingBlockOrComponentProps
> = compose(purifyWithDeepCheck, defaultProps(defaultPropsValue));

export default enhanceLoadingBlockOrComponent(LoadingBlockOrComponent);
